import React, {useState, useEffect} from "react";
import {getDataReviewOrtreetZip, likeService, upliftService, CommentToCommentModify} from "../services/rating";
import {Link, useNavigate} from "react-router-dom";
import moment from "moment";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import {admin_role_id, super_admin_role_id} from "../constant";

import Rating from "@mui/material/Rating";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import {sweetAlerts} from "../utils/sweet-alerts";
import CustomUserName from "../CustomComponents/CustomUserName";
import Typography from "@mui/material/Typography";
import {fTimeAgo} from "../utils/format-time";
import {Divider} from "antd";

import {Form, Formik} from "formik";

import {TextFieldForm} from "../CustomComponents/inputs";

import * as Yup from "yup";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import CustomUserProfile from "../CustomComponents/CustomUserProfile";

const jobIssuesOptions = [
	{id: "unclear-expectations", label: "Unclear expectations"},
	{id: "scope-changed", label: "Scope changed mid-job"},
	{id: "payment-delayed", label: "Payment delayed"},
	{id: "verbal-aggression", label: "Verbal aggression"},
	{id: "threatened-review", label: "Threatened bad review"},
	{id: "access-issues", label: "Access issues (e.g. locked out, reschedules)"},
	{id: "micromanaged", label: "Client micromanaged"},
	{id: "safety-concerns", label: "Safety concerns"},
	{id: "poor-communication", label: "Poor communication"},
	{id: "other", label: "Other"},
];

const ReviewsListingPage = () => {
	const navigate = useNavigate();
	const [reviews, setReviews] = useState([]);
	const [loading, setLoading] = useState(true);
	const [flag, setFlag] = useState(true);
	const [searchedAddress, setSearchedAddress] = useState(""); // Track likes and uplifts for each review
	const [loadingButtons, setLoadingButtons] = useState({}); // Track loading state for individual buttons

	const [comments, setComments] = useState([]);
	const [allReviewComment, setAllReviewComment] = useState([]);
	const [ratingAvg, setRatingAvg] = useState(5);

	const [selfCreate, setSelfCreate] = useState(false);
	const [role, setRole] = useState(null);

	const [upliftString, setUpliftString] = useState(null);
	const [moderationError, setModerationError] = useState(null);

	const token = localStorage.getItem("auth_token");
	const is_login = localStorage.getItem("is_login");

	// Mock data for now - will be replaced with API call
	useEffect(() => {
		// Simulate API call
		setTimeout(async () => {
			try {
				const searchedAddress = localStorage.getItem("searchedAddress") || "Address not specified";

				setSearchedAddress(searchedAddress);

				const addresses_id = localStorage.getItem("reviews_addresses_id");
				const addresses_string = localStorage.getItem("searchedAddress");

				if (!addresses_id) {
					console.warn("No addresses_id found in localStorage");
					// Set default empty data
					setReviews([]);
					setComments([]);
					setLoading(false);
					return;
				}

				let response = await getDataReviewOrtreetZip(addresses_id, addresses_string);

				let transformedReviews = [];
				let transformedCommet = [];
				setUpliftString(null);
				if (response && response.status === true) {
					const reviewsData = response.data.ratings;
					// Transform the localStorage data to match the expected format
					transformedReviews = reviewsData
						? reviewsData.map((review, index) => {
								// Parse job_issues if it's a JSON string
								let issues = [""];
								try {
									if (review.job_issues && !Array.isArray(review.job_issues)) {
										const parsedIssues = JSON.parse(review.job_issues);
										if (Array.isArray(parsedIssues)) {
											// Convert issue IDs to human-readable labels
											issues = parsedIssues.map((issueId) => {
												const issueOption = jobIssuesOptions.find((option) => option.id === issueId);
												return issueOption ? issueOption.label : issueId;
											});
										} else {
											issues = [""];
										}
									} else if (Array.isArray(review.job_issues)) {
										issues = review?.job_issues || [""];
									} else {
										issues = [""];
									}
								} catch (e) {
									console.error("Error parsing job_issues:", e);
									issues = [""];
								}

								// Format the date
								const jobDate = review.job_date ? new Date(review.job_date) : new Date();
								const formattedDate = jobDate.toISOString().split("T")[0]; // YYYY-MM-DD format
								const fullFormattedDate = moment(formattedDate).format("MMM DD, YYYY");

								const likes = review?.likes || null;
								const trueCount = likes.filter((item) => item?.like == true).length;

								if (review?.selfCreate) {
									const today = new Date();
									const job_date = new Date(review?.job_date);

									// Days passed since job_date
									const diffTime = today - job_date; // in ms
									const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

									// Days left from 30-day window
									const daysLeft = 30 - diffDays;

									if (daysLeft > 1) {
										setUpliftString(`You can uplift a rating for this address in ${daysLeft} days.`);
									} else if (daysLeft === 1) {
										setUpliftString(`You can uplift a rating for this address in 1 day.`);
									}
									setSelfCreate(true);
								}

								return {
									id: review.rating_id || index + 1,
									selfLike: review?.selfLike,
									address: searchedAddress || "Address not specified",
									rating: review.stars || 0,
									reviewText: `Rating submitted on ${fullFormattedDate}. ${issues[0] !== "None" ? `Issues reported: ${issues.join(", ")}.` : "No issues reported."}`,
									reviewer: "Anonymous User", // Default since not provided in data
									role: "Contractor", // Default since not provided in data
									date: fullFormattedDate,
									category: "Construction", // Default since not provided in data
									issues: issues,
									avatar: "👷", // Default avatar
									likes: trueCount,
									upliftCount: review?.upliftCount,
									upliftByUser: review?.upliftByUser,
									selfCreate: review?.selfCreate,
									thisAddressAnyRating: review?.thisAddressAnyRating,
									type: "rating",
									is_historic: review?.is_historic || review?.is_historic == 1 || review?.is_historic != 0 ? true : false,
									user: review?.user,
									job_date: review.job_date,
									parent_uplift_id: review?.parent_uplift_id,
									uplift: review?.uplift,
								};
							})
						: [];

					const commetsData = response.data.comments;

					transformedCommet = commetsData
						? commetsData.map((review, index) => {
								// Format the date
								const jobDate = review.comment_date ? new Date(review.comment_date) : new Date();
								const formattedDate = jobDate.toISOString().split("T")[0]; // YYYY-MM-DD format
								const fullFormattedDate = moment(formattedDate).format("MMM DD, YYYY");
								const likes = review?.likes || null;
								const trueCount = likes.filter((item) => item?.like == true).length;

								console.log(review, "$$$$$$$");

								return {
									id: review.street_id || index + 1,
									selfLike: review?.selfLike,
									address: searchedAddress || "Address not specified",
									commentText: review?.description,
									commenter: review.client_name || "",
									role: "",
									date: fullFormattedDate,
									category: "",
									searchType: review.comment_type ? "Zipcode" : "Street",
									avatar: "👷",
									likes: trueCount,
									selfCreate: review?.selfCreate,
									type: "comment",
									is_historic: review?.is_historic || review?.is_historic == 1 || review?.is_historic != 0 ? true : false,
									user: review?.user,
									job_date: review.comment_date,
									street_id: review?.street_id,
									street_comments: review?.street_comments,
								};
							})
						: [];

					setReviews(transformedReviews);
					setComments(transformedCommet);
				} else {
					console.warn("API response status is false:", response);
					setReviews([]);
					setComments([]);
				}

				setLoading(false);
				setLoadingButtons({});
			} catch (error) {
				console.error("Error fetching reviews and comments:", error);
				setReviews([]);
				setComments([]);
				setLoading(false);
				setLoadingButtons({});
			}
		}, 10);
	}, [flag]);

	const getRatingClass = (rating) => {
		if (rating >= 4.5) return "rating-excellent";
		if (rating >= 3.5) return "rating-good";
		return "rating-poor";
	};

	const handleLikeReview = async (reviewId) => {
		setLoadingButtons((prev) => ({...prev, [`like-review-${reviewId}`]: true}));
		try {
			const response = await likeService({rating_id: reviewId});

			if (response && response.data.status) {
				// Refresh the data after successful like
				// You can call the same API again or update local state
				// For now, we'll update the local state
				setFlag(!flag);
			}
		} catch (error) {
			console.error("Error liking review:", error);
		} finally {
			setLoadingButtons((prev) => ({...prev, [`like-review-${reviewId}`]: false}));
		}
	};

	const handleLikeComment = async (commentId) => {
		if (is_login && token) {
			setLoadingButtons((prev) => ({...prev, [`like-comment-${commentId}`]: true}));
			try {
				const response = await likeService({street_id: commentId});

				if (response && response.data.status) {
					setFlag(!flag);
				}
			} catch (error) {
				console.error("Error liking comment:", error);
			} finally {
				setLoadingButtons((prev) => ({...prev, [`like-comment-${commentId}`]: false}));
			}
		} else {
			navigate("/login");
		}
	};

	const handleUplift = async (reviewId) => {
		if (is_login && token) {
			setLoadingButtons((prev) => ({...prev, [`uplift-${reviewId}`]: true}));
			try {
				const response = await upliftService({rating_id: reviewId});

				if (response && response.data.status) {
					setFlag(!flag);

					sweetAlerts("success", response?.data?.message);
				}
			} catch (error) {
				console.error("Error liking comment:", error);
			} finally {
				setLoadingButtons((prev) => ({...prev, [`uplift-${reviewId}`]: false}));
			}
		} else {
			navigate("/login");
		}
	};

	const commentToCommentAction = async (data) => {
		if (is_login && token) {
			setLoadingButtons((prev) => ({...prev, [`comment-${data?.street_id}`]: true}));
			try {
				const response = await CommentToCommentModify(data);

				if (response && response.data.status) {
					setFlag(!flag);
					sweetAlerts("success", response?.data?.message);
					setModerationError(null);
				} else {
					if (response.data.reasons) {
						setModerationError({
							street_id: data?.street_id,
							message: response.message || "Your comment contains restricted content and cannot be published.",
							reasons: response.data.reasons || [],
							policy_tags: response.data.policy_tags || [],
						});
					} else {
						sweetAlerts("error", response?.message);
					}
				}
			} catch (error) {
				sweetAlerts("error", error?.message);
				setModerationError(null);
				console.error("Error liking comment:", error);
			} finally {
				setLoadingButtons((prev) => ({...prev, [`comment-${data?.street_id}`]: false}));
			}
		} else {
			navigate("/login");
		}
	};

	useEffect(() => {
		const role = localStorage.getItem("role");
		setRole(role);
	}, []);

	useEffect(() => {
		reviews.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
		comments.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

		const merged = is_login && token ? [...reviews, ...comments] : [...comments];

		const newReview = reviews?.filter((item) => !item?.is_historic);

		const dataRating = newReview?.length > 0 ? (newReview.reduce((sum, job) => sum + job.rating, 0) / newReview.length).toFixed(1) : 5;

		setRatingAvg(parseFloat(dataRating));

		setRatingAvg(dataRating);

		const filterList = reviews?.filter((item) => !item?.parent_uplift_id && item?.uplift === false);

		const mergedUp = is_login && token ? [...filterList, ...comments] : [...comments];

		setAllReviewComment(mergedUp);
	}, [comments, reviews]);

	if (loading) {
		return (
			<div className="container mt-5">
				<div className="text-center">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-3">Loading reviews...</p>
				</div>
			</div>
		);
	}

	return (
		<div className="reviews-listing-page">
			<Navbar />
			<div className="container mt-4 mb-5">
				{/* Header */}
				<div>
					<Link to="/" className=" gap-2 btn btn-contractor mb-3">
						<svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 512 512">
							<rect width="512" height="512" fill="none" />
							<path fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M244 400L100 256l144-144M120 256h292" />
						</svg>
						Back
					</Link>
				</div>

				<div className="row mb-4">
					<div className="col-12">
						<div>
							<h1 className="mb-2" style={{fontSize: "clamp(1.1rem, 4vw, 1.75rem)"}}>
								Reviews & Comments for "<strong>{searchedAddress}</strong>"
							</h1>
							<p className="text-muted mb-0" style={{fontSize: "clamp(0.75rem, 2vw, 1rem)"}}>
								Browse through all contractor reviews, ratings, and comments for this address
							</p>
						</div>
					</div>
				</div>
				{allReviewComment.length === 0 && (
					<div className="mb-3 pb-0">
						<Alert severity="info">For privacy, one rating doesn’t change the default 5-stars until second rating appears.</Alert>
					</div>
				)}

				<div className="attachment-item mb-3 pb-0">
					<Box sx={{display: "flex", alignItems: "center", flexWrap: {xs: "wrap", md: "nowrap"}, gap: {xs: 1, md: 1.5}}} gap={1.5}>
						<h1 style={{margin: 0, fontSize: "clamp(1.2rem, 3vw, 2rem)"}}>{ratingAvg || 5}</h1>
						<Rating value={ratingAvg} precision={0.5} name="size-large" defaultValue={2} size="large" readOnly sx={{fontSize: {xs: "1.2rem", md: "2rem"}}} />
						<Box sx={{display: "flex", flexWrap: "wrap", gap: {xs: 0.5, md: 1}, alignItems: "center"}}>
							<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
								({reviews?.filter((item) => !item?.is_historic)?.length || 0}) reviews
							</span>
							<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
								({comments?.filter((item) => !item?.is_historic)?.length || 0}) comments
							</span>
							<span className="text-muted d-none d-md-inline" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
								{" "}
								|{" "}
							</span>
							<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
								({reviews?.filter((item) => item?.is_historic || item?.is_historic == 1)?.length || 0}) Old reviews
							</span>
							<span className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 1rem)"}}>
								({comments?.filter((item) => item?.is_historic || item?.is_historic == 1)?.length || 0}) Old comments
							</span>
						</Box>
					</Box>
				</div>

				<div>
					{allReviewComment.length === 0 && (
						<div className="text-center py-5">
							<div className="mb-3">
								<svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-muted">
									<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</div>
							<h4>No Reviews & Comments found</h4>
							<p className="text-muted">No reviews & comments match the selected filter criteria.</p>
						</div>
					)}
					<div>
						<div className="row">
							{allReviewComment?.length > 0 &&
								allReviewComment?.map((item, key) => {
									if (item?.type === "rating") {
										return (
											<div key={key} className="col-12 mb-3">
												<div className={`card ${item?.selfCreate === 1 ? "border-primary border-2" : "border-0"} shadow-sm ${item?.selfCreate === 1 ? "bg-light" : ""}`}>
													{/* Self-created indicator badge */}

													{item?.selfCreate === 1 && (
														<div className="card-header bg-primary text-white py-2">
															<div className="d-flex align-items-center">
																<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2" style={{width: "clamp(12px, 2vw, 16px)", height: "clamp(12px, 2vw, 16px)"}}>
																	<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
																</svg>
																<span className="fw-semibold" style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																	Your Review
																</span>
															</div>
														</div>
													)}

													{(item?.is_historic || item?.is_historic == 1) && (
														<div className="card-header bg-secondary text-white py-2">
															<div className="d-flex align-items-center">
																<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2" style={{width: "clamp(12px, 2vw, 16px)", height: "clamp(12px, 2vw, 16px)"}}>
																	<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
																</svg>
																<span className="fw-semibold" style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																	Old Review
																</span>
															</div>
														</div>
													)}
													<div className="card-body py-3">
														<div className="row align-items-center g-0">
															<Box sx={{display: "flex", justifyContent: "space-between", mb: 2, flexWrap: {xs: "wrap", md: "nowrap"}, gap: {xs: 1, md: 0}}}>
																<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
																	<CustomUserProfile user={item?.user} sx={{fontWeight: 900}} code />
																	<Box sx={{}}>
																		<span className="text-blue text-capitalize">
																			<CustomUserName user={item?.user} sx={{fontWeight: 900, fontSize: {xs: "0.85rem", md: "1rem"}}} code />
																		</span>
																		<div className="text-body-secondary">
																			<Typography variant="body2" sx={{fontSize: {xs: 10, md: 12}, fontWeight: 600}}>
																				{fTimeAgo(item?.job_date)}
																			</Typography>
																		</div>
																	</Box>
																</Box>

																<Box sx={{mt: {xs: 1, md: 0}}}>
																	<div className={`search-type-badge rating-badge`} style={{fontSize: "clamp(0.7rem, 2vw, 0.9rem)"}}>
																		<span className="search-type-icon me-2">★</span>
																		<span className="search-type-text">Rating</span>
																	</div>
																</Box>
															</Box>

															<div className="col-12 col-md-4 d-flex mb-2 mb-md-0">
																<div className="d-flex align-items-center">
																	<div className={`rating-display-compact ${getRatingClass(item.rating)} me-3`} style={{fontSize: "clamp(0.8rem, 2vw, 1rem)"}}>
																		<div className="stars-compact">
																			{[1, 2, 3, 4, 5].map((star) => (
																				<span key={star} className={`star-compact ${star <= item.rating ? "filled" : ""}`}>
																					★
																				</span>
																			))}
																		</div>
																		<span className="rating-number-compact ms-2">{item.rating}/5</span>
																	</div>
																</div>
															</div>

															<div className="col-12 col-md-4 mb-2 mb-md-0">
																{/* Issues */}
																{item?.issues && item?.issues.length > 0 && item?.issues[0] !== "None" ? (
																	<div className="text-center text-md-center">
																		<div className="text-muted mb-1" style={{fontSize: "clamp(0.7rem, 2vw, 0.875rem)"}}>
																			Issues:
																		</div>
																		<div className="d-flex flex-wrap gap-1 justify-content-center">
																			{item.issues.map((issue, index) => (
																				<span key={index} className="badge bg-warning text-dark px-2 py-1" style={{fontSize: "clamp(0.65rem, 2vw, 0.8rem)"}}>
																					{issue}
																				</span>
																			))}
																		</div>
																	</div>
																) : (
																	<div className="text-center text-md-center">
																		<div className="text-muted" style={{fontSize: "clamp(0.7rem, 2vw, 0.875rem)"}}>
																			No issues
																		</div>
																	</div>
																)}
															</div>

															<div className="col-12 col-md-4">
																<div className="text-start text-md-end">
																	<div className="text-muted mb-1" style={{fontSize: "clamp(0.7rem, 2vw, 0.875rem)"}}>
																		Submitted
																	</div>
																	<div className="fw-semibold text-dark" style={{fontSize: "clamp(0.8rem, 2vw, 1rem)"}}>
																		{item?.date}
																	</div>
																</div>
															</div>
														</div>

														{role !== super_admin_role_id && role !== admin_role_id && (
															<div className="row mt-3">
																<div className="col-12">
																	<div className="interaction-buttons border-top pt-3 d-flex flex-wrap gap-2">
																		<Tooltip
																			placement="top"
																			title={
																				item?.is_historic
																					? "You cannot Like/Unlike Old Review rating"
																					: item?.selfCreate
																						? "You cannot like your own rating"
																						: item?.selfLike?.like
																							? "Unlike this rating"
																							: "Like this rating"
																			}
																			// title={item?.selfCreate ? "You cannot like your own rating" : item?.is_historic ? "You cannot like Historic rating" : ""}
																			arrow>
																			<span>
																				<button
																					className={`interaction-btn like-btn   ${item?.selfLike?.like ? "active" : ""} ${item?.selfCreate ? "disabled" : item?.is_historic ? "disabled" : ""}`}
																					title="Like this rating"
																					onClick={() => !item?.selfCreate && !item?.is_historic && handleLikeReview(item.id)}
																					style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																					<div className={item?.selfLike?.like ? "bi-hand-thumbs-up-fill" : "bi-hand-thumbs-up"} style={{fontSize: "clamp(12px, 2vw, 14px)"}} />

																					<span>Like</span>
																					<span>({item?.likes || 0})</span>
																				</button>
																			</span>
																		</Tooltip>

																		<Tooltip
																			placement="top"
																			// title={item?.selfCreate ? "You cannot uplift your own rating" : upliftString ? upliftString : item?.is_historic ? "You cannot uplift Historic rating" : ""}
																			title={
																				item?.is_historic
																					? "You cannot uplift Old rating"
																					: item?.selfCreate
																						? "You cannot uplift your own rating"
																						: upliftString
																							? upliftString
																							: item?.upliftByUser
																								? "Remove Uplift this rating"
																								: "Uplift this rating"
																			}
																			arrow>
																			<span>
																				<button
																					className={`interaction-btn uplift-btn ${item?.upliftByUser ? "active" : ""} 
																						${item?.selfCreate ? "disabled" : item?.upliftByUser ? "" : upliftString ? "disabled" : item?.is_historic ? "disabled" : ""} `}
																					title="Uplift this rating"
																					onClick={() => (item?.selfCreate ? "" : item?.upliftByUser ? handleUplift(item.id) : upliftString ? "" : item?.is_historic ? "" : handleUplift(item.id))}
																					style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{width: "clamp(12px, 2vw, 16px)", height: "clamp(12px, 2vw, 16px)"}}>
																						<path d="M12 19V5M5 12l7-7 7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
																					</svg>
																					<span>Uplift</span>
																					<span>({item?.upliftCount || 0})</span>
																				</button>
																			</span>
																		</Tooltip>
																	</div>
																</div>
															</div>
														)}
													</div>
												</div>
											</div>
										);
									}

									if (item?.type === "comment") {
										return (
											<div key={item.id} className="col-12 mb-3">
												<div className={`card ${item?.selfCreate === 1 ? "border-success border-2" : "border-0"} shadow-sm ${item?.selfCreate === 1 ? "bg-light" : ""}`}>
													{item?.selfCreate === 1 && (
														<div className="card-header bg-success text-white py-2">
															<div className="d-flex align-items-center">
																<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2" style={{width: "clamp(12px, 2vw, 16px)", height: "clamp(12px, 2vw, 16px)"}}>
																	<path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
																</svg>
																<span className="fw-semibold" style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																	Your Comment
																</span>
															</div>
														</div>
													)}
													{(item?.is_historic || item?.is_historic == 1) && (
														<div className="card-header bg-secondary text-white py-2">
															<div className="d-flex align-items-center">
																<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="me-2" style={{width: "clamp(12px, 2vw, 16px)", height: "clamp(12px, 2vw, 16px)"}}>
																	<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
																</svg>
																<span className="fw-semibold" style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																	Old Comment
																</span>
															</div>
														</div>
													)}
													<div className="card-body py-3">
														<div className="row g-0">
															<Box sx={{display: "flex", justifyContent: "space-between", mb: 2, flexWrap: {xs: "wrap", md: "nowrap"}, gap: {xs: 1, md: 0}}}>
																<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
																	<CustomUserProfile user={item?.user} sx={{fontWeight: 900}} />
																	<Box sx={{}}>
																		<span className="text-blue text-capitalize">
																			<CustomUserName user={item?.user} sx={{fontWeight: 900, fontSize: {xs: "0.85rem", md: "1rem"}}} />
																		</span>
																		<div className="text-body-secondary">
																			<Typography variant="body2" sx={{fontSize: {xs: 10, md: 12}, fontWeight: 600}}>
																				{fTimeAgo(item?.job_date)}
																			</Typography>
																		</div>
																	</Box>
																</Box>

																<Box sx={{mt: {xs: 1, md: 0}}}>
																	<div className="d-flex align-items-center">
																		<div className={`search-type-badge ${item.searchType === "Street" ? "street-badge" : "zipcode-badge"}`} style={{fontSize: "clamp(0.7rem, 2vw, 0.9rem)"}}>
																			<span className="search-type-icon me-2">{item.searchType === "Street" ? "🏘️" : "📍"}</span>
																			<span className="search-type-text">{item.searchType}</span>
																		</div>
																	</div>
																</Box>
															</Box>

															<div className="row g-0 align-items-center">
																<div className="col-12 col-md-8 mb-2 mb-md-0">
																	<Typography variant="body2" sx={{fontSize: {xs: 14, md: 20}, mb: {xs: 1, md: 2}, px: {xs: 0, md: 1}}}>
																		{item.commentText}
																	</Typography>
																</div>
																<div className="col-12 col-md-4">
																	<div className="text-start text-md-end">
																		<div className="text-muted mb-1" style={{fontSize: "clamp(0.7rem, 2vw, 0.875rem)"}}>
																			Commented on
																		</div>
																		<div className="fw-semibold text-dark" style={{fontSize: "clamp(0.8rem, 2vw, 1rem)"}}>
																			{item?.date}
																		</div>
																	</div>
																</div>
															</div>

															<Divider sx={{p: 0, m: 0}} />

															{role !== super_admin_role_id && role !== admin_role_id && (
																<div className="d-flex flex-wrap gap-2">
																	<Tooltip
																		placement="top"
																		title={
																			item?.selfCreate ? "You cannot Like/Unlike your own comment" : item?.is_historic ? "You cannot like Old comment" : item?.selfLike?.like ? "Unlike this comment" : "Like this comment"
																		}
																		arrow>
																		<span>
																			<button
																				className={`interaction-btn like-btn ${item?.selfLike?.like ? "active" : ""} ${item?.selfCreate ? "disabled" : item?.is_historic ? "disabled" : ""}`}
																				onClick={() => !item?.selfCreate && !item?.is_historic && handleLikeComment(item.id)}
																				title="Like this comment"
																				style={{fontSize: "clamp(0.75rem, 2vw, 0.9rem)"}}>
																				<div className={item?.selfLike?.like ? "bi-hand-thumbs-up-fill" : "bi-hand-thumbs-up"} style={{fontSize: "clamp(12px, 2vw, 14px)"}} />
																				<span>Like</span>
																				<span>({item?.likes || 0})</span>
																			</button>
																		</span>
																	</Tooltip>
																</div>
															)}
														</div>
													</div>

													<Box sx={{px: {xs: 2, md: 3}, pl: {xs: 2, md: 5}}}>
														{item?.street_comments &&
															item?.street_comments?.length > 0 &&
															item?.street_comments?.map((comment) => {
																return (
																	<div key={comment?.id || Math.random()} className="attachment-item d-flex flex-column flex-md-row mb-2">
																		<Box sx={{mb: 1, flex: 1}}>
																			<span className="text-blue text-capitalize">
																				<Box sx={{display: "flex", alignItems: "center", gap: 1}}>
																					<CustomUserProfile user={comment?.user} width={32} sx={{fontSize: {xs: 11, md: 13}}} />
																					<CustomUserName user={comment?.user} sx={{fontWeight: 900, fontSize: {xs: 12, md: 14}}} />
																				</Box>
																			</span>
																			<div className="text-body-secondary" style={{fontSize: "clamp(0.8rem, 2vw, 0.9rem)"}}>
																				{comment?.description}
																			</div>
																		</Box>
																		<Typography variant="body2" sx={{fontSize: {xs: 10, md: 12}, fontWeight: 600, mt: {xs: 0.5, md: 0}}}>
																			{fTimeAgo(comment?.createdAt)}
																		</Typography>
																	</div>
																);
															})}
													</Box>

													{role !== super_admin_role_id && role !== admin_role_id && item?.is_historic != 1 && (
														<Formik
															enableReinitialize
															initialValues={{
																street_id: item?.street_id,
																comment_text: "",
															}}
															validationSchema={Yup.object().shape({
																comment_text: Yup.string().trim().required("Comment is required."),
															})}
															onSubmit={async (values, {resetForm}) => {
																setModerationError();
																await commentToCommentAction(values);
																resetForm();
															}}>
															{(props) => {
																const {handleSubmit} = props;
																return (
																	<Form noValidate>
																		{moderationError && item?.street_id == moderationError?.street_id && (
																			<div
																				className="moderation-error-alert mx-3"
																				style={{
																					backgroundColor: "#fee",
																					border: "1px solid #fcc",
																					borderRadius: "4px",
																					padding: "12px",
																					marginBottom: "10px",
																					color: "#c33",
																				}}>
																				<strong style={{display: "block", marginBottom: "8px"}}>{moderationError.message}</strong>
																				{moderationError.reasons && moderationError.reasons.length > 0 && (
																					<div style={{fontSize: "14px", marginTop: "8px"}}>
																						<strong>Reasons:</strong>
																						<ul style={{margin: "4px 0 0 20px", padding: 0}}>
																							{moderationError.reasons.map((reason, idx) => (
																								<li key={idx}>{reason}</li>
																							))}
																						</ul>
																					</div>
																				)}
																				{moderationError.policy_tags && moderationError.policy_tags.length > 0 && (
																					<div style={{fontSize: "12px", marginTop: "8px", color: "#999"}}>Tags: {moderationError.policy_tags.join(", ")}</div>
																				)}
																			</div>
																		)}
																		<Box
																			sx={{
																				p: {xs: 1, md: 2},
																				display: "flex",
																				flexDirection: "column",
																				gap: {xs: 1, md: 2},
																			}}>
																			<TextFieldForm placeholder="Write a comment ..." required={false} formik={props} field="comment_text" rows={2} disabled={loadingButtons[`comment-${item?.street_id}`]} />

																			<Box sx={{display: "flex", justifyContent: "flex-end"}}>
																				<Button
																					variant="contained"
																					type="submit"
																					onClick={handleSubmit}
																					color="info"
																					disabled={loadingButtons[`comment-${item?.street_id}`]}
																					startIcon={loadingButtons[`comment-${item?.street_id}`] ? <CircularProgress size={16} color="inherit" /> : null}>
																					{loadingButtons[`comment-${item?.street_id}`] ? "Submitting..." : "Comment"}
																				</Button>
																			</Box>
																		</Box>
																	</Form>
																);
															}}
														</Formik>
													)}
												</div>
											</div>
										);
									}
								})}
						</div>
					</div>
				</div>

				<div className="add-review-section-inline text-center border-0 p-0 d-none d-lg-block">
					<div className="d-flex flex-column flex-md-row gap-3 justify-content-center">
						<button
							className="btn btn-success btn-lg"
							onClick={() => {
								navigate("/", {state: {address: searchedAddress, from: "review"}});
							}}>
							<span className="me-2">★</span>
							Add Your Review
						</button>
						<button
							className="btn btn-success btn-lg"
							onClick={() => {
								navigate("/", {state: {address: searchedAddress, from: "street"}});
							}}>
							<span className="me-2">🏘️</span>
							Street Comment
						</button>
						<button
							className="btn btn-success btn-lg"
							onClick={() => {
								navigate("/", {state: {address: searchedAddress, from: "zipcode"}});
							}}>
							<span className="me-2">📍</span>
							Zipcode Comment
						</button>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default ReviewsListingPage;
